module.exports = __webpack_public_path__ + "assets/img/8_1674.16a01456.jpg";